import React from "react";
import "./NavButtons.scss";
import audioHover from "../../assets/hover.wav";
import audioPress from "../../assets/press.wav";
const audioOnHover = new Audio(audioHover);
const audioOnPress = new Audio(audioPress);

function NavButtons({
  handleClickNavButtons,
  buttonActive,
  exploreTheStates,
  supplyRef,
  appRef,
  affRef,
  forecastRef,
  mobileView,
}) {
  const playAudio = (event, src, category) => {
    if (category) {
      handleClickNavButtons(category);
      event.src = src;
    }
    if (event === audioOnHover) {
      if (!mobileView) {
        event.play().catch((e) => {
          console.log(e);
        });
      }
    } else {
      event.play().catch((e) => {
        console.log(e);
      });
    }
  };
  return (
    <nav className="nav">
      <div className="nav__contents">
        <button
          className={
            buttonActive === "intro"
              ? "buttons buttons--intro buttons--active buttons--active-stateView"
              : "buttons buttons--intro stateView"
          }
          onClick={() => {
            playAudio(audioOnPress, audioPress, "intro");
          }}
          onMouseEnter={() => {
            playAudio(audioOnHover, audioHover);
          }}
        >
          State View
        </button>
        <div className="keyAreas">
          <div className="nav__keyAreas">
            <div className="keyAreas__divider" />
            <p className="keyAreas__copy" ref={exploreTheStates}>
              4 Key Factors
            </p>
          </div>
          <div className="nav__keyAreas__buttons">
            <div className="buttons__container">
              <div className="buttons__divider" />
              <button
                id="housingShortage"
                ref={supplyRef}
                className={
                  buttonActive === "supply"
                    ? "buttons buttons--supply buttons--active buttons--active-housingShortage"
                    : "buttons buttons--supply housingShortage"
                }
                onClick={() => {
                  playAudio(audioOnPress, audioPress, "supply");
                }}
                onMouseEnter={() => {
                  playAudio(audioOnHover, audioHover);
                }}
              >
                Housing Shortage
              </button>
            </div>
            <div className="buttons__container">
              <div className="buttons__divider" />
              <button
                id="homePriceAppreciation"
                ref={appRef}
                className={
                  buttonActive === "appreciation"
                    ? "buttons buttons--active buttons--active-homePrice"
                    : "buttons homePrice"
                }
                onClick={() => {
                  playAudio(audioOnPress, audioPress, "appreciation");
                }}
                onMouseEnter={() => {
                  playAudio(audioOnHover, audioHover);
                }}
              >
                Home Price Appreciation
              </button>
            </div>
            <div className="buttons__container">
              <div className="buttons__divider" />
              <button
                id="affordability"
                ref={affRef}
                className={
                  buttonActive === "affordability"
                    ? "buttons buttons--active buttons--active-affordability"
                    : "buttons affordability"
                }
                onClick={() => {
                  playAudio(audioOnPress, audioPress, "affordability");
                }}
                onMouseEnter={() => {
                  playAudio(audioOnHover, audioHover);
                }}
              >
                <span className="buttons__text">Affordability</span>
              </button>
            </div>
            <div className="buttons__container">
              <div className="buttons__divider" />
              <button
                id="housingDemandForecast"
                ref={forecastRef}
                className={
                  buttonActive === "forecast"
                    ? "buttons buttons--active buttons--active-housingDemand"
                    : "buttons housingDemand"
                }
                onClick={() => {
                  playAudio(audioOnPress, audioPress, "forecast");
                }}
                onMouseEnter={() => {
                  playAudio(audioOnHover, audioHover);
                }}
              >
                Housing Demand Forecast
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavButtons;
